<script>
import { getDoluFromDbase, readAllCategories } from '@/services/MindMovieServices';
import NewCategory from './NewCategory.vue';
import SingleCategory from './SingleCategory.vue';

export default {
  components: {
    NewCategory,
    SingleCategory,
  },
  data() {
    return {
      uId: localStorage.getItem('uId'),
      token: localStorage.getItem('idToken'),

      localDoluCategories: localStorage.getItem('doluCategories'),
      localCategories: JSON.parse(localStorage.getItem('categories')),

      // UI
      categories: null,
      categoriesIds: null,
    };
  },
  methods: {
    async getLatestCategoriesFromDbase() {
      const dbaseDolu = await getDoluFromDbase(this.uId, this.token);
      // console.log(`*** localDoluCategories: ${this.localDoluCategories} ***`);
      // console.log(`*** localCategories: ${JSON.stringify(this.localCategories)} ***`);
      // console.log(`*** dbaseDolu: ${JSON.stringify(dbaseDolu)} ***`);


      if (!this.localCategories || !this.localDoluCategories || dbaseDolu.categories !== this.localDoluCategories) {
        // get from dbase, then set localStorage: categories, dolu.categories
        this.categories = await readAllCategories(this.uId, this.token);
        localStorage.setItem('categories', JSON.stringify(this.categories));
        localStorage.setItem('doluCategories', dbaseDolu.categories);

        // console.log('*** bc of conditions, getting new categories ***');
      }
      else if (dbaseDolu.categories === this.localDoluCategories) {
        this.categories = this.localCategories;
        // console.log('*** using categories from localStorage ***');
      }

      this.categoriesIds = Object.keys(this.categories);
    },
    newCategoryWasCreated(category) {
      // add category to this.categories
      this.categories[category.id] = { name: category.name };
      this.categoriesIds = Object.keys(this.categories);
    },
  },
  async created() {
    console.clear();
    await this.getLatestCategoriesFromDbase();
  },
};
</script>

<template>
  <div id="page-mind-movie-categories">

    <h1 class="text-center pt-3">mind movie categories</h1>

    <!-- ADD NEW CATEGORY -->
    <div class="py-2 px-4">
      <NewCategory @new-category-was-created="newCategoryWasCreated" />
    </div>


    <!-- DISPLAY ALL CATEGORIES -->
    <div class="my-16 pa-4">
      <p class="text-center font-italic">{{categoriesIds.length}} categories</p>
      <SingleCategory v-for="id of categoriesIds" :propCategory="{ id: id, name: categories[id].name }" :key="id" />
    </div>

  </div>
</template>

<style scoped lang="scss">
#page-mind-movie-categories {
  color: black;

  @media screen and (min-width: 768px) {
    padding-left: 0;
    padding-right: 0;
    max-width: 600px;
    margin: 0 auto
  }
}
</style>
